import { render, staticRenderFns } from "./JcdcCardList.vue?vue&type=template&id=61cd6e5e"
import script from "./JcdcCardList.vue?vue&type=script&lang=ts"
export * from "./JcdcCardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports